import { useAuthContext } from 'auth/authContext'
import { useLoadVersion } from 'queries/version/useLoadVersion'
import { useEffect, useMemo } from 'react'

import useCache from './useCache'

const useCheckVersion = () => {
  const { getCache, setCache } = useCache()
  const { data, isFetching } = useLoadVersion()
  const { isAuthenticated } = useAuthContext()

  // Memoize getCache and setCache to optimize performance
  const memoizedGetCache = useMemo(() => getCache, [getCache])
  const memoizedSetCache = useMemo(() => setCache, [setCache])

  useEffect(() => {
    const checkVersionAndAlert = async () => {
      const cachedVersion = memoizedGetCache('version')
      if (
        isAuthenticated &&
        data?.version &&
        data.version !== cachedVersion?.version
      ) {
        memoizedSetCache('version', data)
        if (cachedVersion?.version) {
          await new Promise((resolve) => {
            window.alert('A new version is available. Click OK to refresh.')
            resolve()
          })
          // Not the first time the app is loaded
          window.location.reload(true) // Force a refresh after alert is closed
        }
      }
    }

    checkVersionAndAlert()
  }, [data, isAuthenticated, memoizedGetCache, memoizedSetCache])

  return {
    version: data?.version,
    isFetching,
  }
}

export default useCheckVersion
